export enum Enumvalues {
  VALUE_1 = '1',
  VALUE_2 = '2',
  VALUE_3 = '3',
  VALUE_4 = '4'
}
export class ActiveUserConstants {
  static readonly NAME_SEARCH = 'namesearch';
  static readonly EMAIL_SEARCH = 'emailsearch';
  static readonly RETAILHQ_VALUE_SEARCH = 'retailernamesearch';
  static readonly STORE_VALUE_SEARCH = 'storenamesearch';
  static readonly RETAILHQ_VALUE_FILTER = 'retailerNamefilter';
  static readonly RETAIL_VALUE_FILTER = 'retailerNameFilter';
  static readonly ROLE_VALUE_FILTER = 'rolefilter';
  static readonly COUNTRIES_VALUE_FILTER = 'locationfilter';
  static readonly COUNTRY_VALUE_FILTER = 'countryFilter';
  static readonly COUNTRY_FILTER = 'countryfilter';
  static readonly STATE_VALUE_FILTER = 'stateRegionProvinceFilter';
  static readonly STATE_FILTER = 'stateRegionProvincefilter';
  static readonly NAME = $localize`:@@active-users.dropdown-text.name:Name`;
  static readonly EMAIL = $localize`:@@active-users.dropdown-text.email:Email`;
  static readonly RETAILHQ_VALUE = $localize`:@@active-users.dropdown-text.retail-hq:Retail HQ`;
  static readonly CUSTOM_STOREID_VALUE ='Custom Store ID';
  static readonly DEVICE_EXECUTIVE_VALUE = $localize`:@@active-users.dropdown-text.device-executive:Device Executive`;
  static readonly STORE_ROLE_INVITE = $localize`:@@active-users.label-store.store:Store`;
  static readonly STORE_VALUE = $localize`:@@active-users.dropdown-text.stores:Stores`;
  static readonly NAME_SORT = 'name';
  static readonly EMAIL_SORT = 'email';
  static readonly STORENAME_SORT = 'storeName';
  static readonly RETAILER_SORT = 'retailerName';
  static readonly COUNTRY_SORT = 'location';
  static readonly CREATED_BY_SORT = 'userID';
  static readonly EMPTY_VALUE = '';
  static readonly ASCENDING_ORDER = 'asc';
  static readonly SLASH_USER_MANAGEMENT = '/user-mgmt/';
  static readonly USER_MANAGEMENT = 'usermanagment/';
  static readonly SLASH_USER = 'users';
  static readonly SLASH_CONVERT_USER = '/convert';
  static readonly ACTION_TRANSFER = "transfer";
  static readonly SEARCH_QUERY = '?';
  static readonly EQUALS = '=';
  static readonly SORT_BY = 'sortby';
  static readonly SORT_TYPE = 'sorttype';
  static readonly STATUS_ACTIVE = '?status';
  static readonly ACTIVE = 'active';
  static readonly AND = '&';
  static readonly RETAIL_USER_ROLE = 'retailHQUser';
  static readonly SLASH_RETAIL = '/retailer';
  static readonly RETAILERID = '?retailerid';
  static readonly SLASH = '/';
  static readonly AND_STATUS = '&status';
  static readonly STORE = '/store';
  static readonly STOREID = '?storeid';
  static readonly STORE_ROLE = 'storeUser';
  static readonly DOWNLOAD = 'download';
  static readonly PLACEHOLDER_STORES_INVITE = $localize`:@@active-users.input.placeholder-storeinvite:Enter all email addresses to which you would like to send the invite`;
  static readonly PAGE_NUMBER = '&pagenumber';
  static readonly RETAILER_ID = '?retailerId';
  static readonly INTEL_ADMIN = $localize`:@@active-users.label-intel-admin:Intel Admin`;
  static readonly REGIONAL_HQ = $localize`:@@active-users.label-regional-hq:Regional HQ`;
  static readonly NON_CONNECTED_LABEL = $localize`:@@active-users.label-non-connected:Non Connected`;
  static readonly REGIONAL_USER_ROLE = 'regionalHQ';
  //SRT USER ROLE
  static readonly PROFILE_CREATED = 'profileCount';
  static readonly PC_FINDER_USER = 'PC Finder User';
}
